import { useCallback, useState } from 'react'

import { patch } from '@/services/reject/patch'

export const useRejectPatch = () => {
  const [isLoading, setIsLoading] = useState(false)

  const rejectPatch = useCallback(
    async ({
      collectId,
      recusadoPor,
      itensRecusados,
      motivoRecusa
    }: {
      collectId: string
      recusadoPor: string
      itensRecusados: string[]
      motivoRecusa: string
    }) => {
      try {
        setIsLoading(true)
        const response = await patch({
          collectId,
          recusadoPor,
          itensRecusados,
          motivoRecusa
        })

        return response
      } catch (error) {
        return error
      } finally {
        setIsLoading(false)
      }
    },
    []
  )

  return { rejectPatch, isLoading }
}
